import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import { usePageTitle } from '../hooks/usePageTitle';
import { useState } from 'react';

const ContactPage = () => {
      usePageTitle('Contact Us');
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);

    const handleSubmit = (event) => {
        event.preventDefault();

        setShowSuccessMessage(true);
        const form = event.target;
        form.reset();

        setTimeout(() => {
            setShowSuccessMessage(false);
        }, 5000);
    };

    return (
        <>
            <section className="page-header">
                <h1>📬 CONTACT US 📬</h1>
                <p style={{ color: '#66ff66', fontSize: '1.2rem' }}>
                    We'd love to hear from you!
                </p>
                <Link to="/" className="back-button">
                    ← BACK TO HOME
                </Link>
            </section>

            <div className="contact-container">
                <div className="contact-form-section">
                    <h2>💬 SEND US A MESSAGE</h2>
                    <div
                        className="success-message"
                        id="successMessage"
                        style={{ display: showSuccessMessage ? 'block' : 'none' }}
                    >
                        ✅ Thank you! Your message has been received. We'll get back to you soon!
                    </div>

                    <form id="contactForm" onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="name">NAME *</label>
                            <input type="text" id="name" name="name" required placeholder="Enter your name" />
                        </div>
                        <div className="form-group">
                            <label htmlFor="email">EMAIL *</label>
                            <input type="email" id="email" name="email" required placeholder="your.email@example.com" />
                        </div>
                        <div className="form-group">
                            <label htmlFor="subject">SUBJECT *</label>
                            <input type="text" id="subject" name="subject" required placeholder="What is this about?" />
                        </div>
                        <div className="form-group">
                            <label htmlFor="message">MESSAGE *</label>
                            <textarea id="message" name="message" required placeholder="Write your message here..."></textarea>
                        </div>
                        <button type="submit" className="submit-button">SEND MESSAGE</button>
                    </form>
                </div>
                <Footer />
            </div>
        </>
    );
}

export default ContactPage;